import { PartyRolesService } from './../service/party-roles.service';
import { ContactMechanismTypes } from './../model/contact-mechanism-types.model';
import { City } from './../../common-components/location/model/city.model';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PartyContactMechanisms } from '../model/party-contact-mechanisms.model';
import { PartyRoleTypes } from '../model/party-role-types.model';
import { PartiesService } from '../service/parties.service';
import { State } from '../../common-components/location/model/state.model';
import { PostalCode } from '../../common-components/location/model/postal-code.model';
import { ContactMechanismsService } from '../service/contact-mechanisms.service';
import { ContactMechanismPurposeTypes } from '../model/contact-mechanism-purpose-types.model';
import { GeographicalRegions } from '../model/geographicalRegions.model';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';

export class editPartyContactMechanismInterface {
    emails!: {
        title: string;
        header: string;
        enabled: boolean;
        current: PartyContactMechanisms[];
        past: PartyContactMechanisms[];
        delete: PartyContactMechanisms[];
        inserting: boolean;
        editing: boolean;
        edit: PartyContactMechanisms;
        target: PartyContactMechanisms;
    };
    postalAddresses!: {
        title: string;
        header: string;
        enabled: boolean;
        current: PartyContactMechanisms[];
        past: PartyContactMechanisms[];
        delete: PartyContactMechanisms[];
        inserting: boolean;
        editing: boolean;
        edit: PartyContactMechanisms;
        target: PartyContactMechanisms;
    };
    phoneNumbers!: {
        title: string;
        header: string;
        enabled: boolean;
        current: PartyContactMechanisms[];
        past: PartyContactMechanisms[];
        delete: PartyContactMechanisms[];
        inserting: boolean;
        editing: boolean;
        edit: PartyContactMechanisms;
        target: PartyContactMechanisms;
    };
    contactPersons!: {
        title: string;
        header: string;
        enabled: boolean;
        current: PartyContactMechanisms[];
        past: PartyContactMechanisms[];
        delete: PartyContactMechanisms[];
        inserting: boolean;
        editing: boolean;
        edit: PartyContactMechanisms;
        target: PartyContactMechanisms;
    };
}

@Component({
    selector: 'edit-party-contact-mechanism',
    templateUrl: './edit-party-contact-mechanism.component.html',
    styleUrls: ['./edit-party-contact-mechanism.component.scss']
})
export class EditPartyContactMechanismComponent implements OnInit {
    @Input() partyId!: number;
    @Input() type!: 'People' | 'Organization';
    @Input() enabledTypes: Array<keyof editPartyContactMechanismInterface> = ['emails', 'postalAddresses', 'phoneNumbers', 'contactPersons']; // Used to display certain types only
    @Input() filterContactPersonTypes: string[] = [];
    @Input() filterAddressTypes: string[] = [];
    @Input() filterEmailTypes: string[] = [];
    @Input() filterPhoneNumberTypes: string[] = [];
    @Input() removeContactPersonTypes: string[] = [];
    @Input() removeAddressTypes: string[] = [];
    @Input() removeEmailTypes: string[] = [];
    @Input() removePhoneNumberTypes: string[] = [];
    @Input() isEditing: boolean = false;
    @Output() isEditingChange: EventEmitter<any> = new EventEmitter<boolean>();
    @Output() partyContactMechanismsChange: EventEmitter<any> = new EventEmitter<any>();

    results: editPartyContactMechanismInterface = {
        postalAddresses: {
            title: 'Addresses',
            header: 'Address',
            enabled: false,
            current: [],
            past: [],
            delete: [],
            inserting: false,
            editing: false,
            edit: {},
            target: {}
        },
        phoneNumbers: {
            title: 'Phone Numbers',
            header: 'Phone',
            enabled: false,
            current: [],
            past: [],
            delete: [],
            inserting: false,
            editing: false,
            edit: {},
            target: {}
        },
        emails: { title: 'Emails', header: 'Email', enabled: false, current: [], past: [], delete: [], inserting: false, editing: false, edit: {}, target: {} },
        contactPersons: {
            title: 'Contact Persons',
            header: 'Contact Person',
            enabled: false,
            current: [],
            past: [],
            delete: [],
            inserting: false,
            editing: false,
            edit: {},
            target: {}
        }
    };
    partyContactMechanisms: PartyContactMechanisms[] = [];
    contactMechanismTypes: ContactMechanismTypes[] = [];
    contactMechanismPurposeTypes: ContactMechanismPurposeTypes[] = [];
    geographicalRegions: GeographicalRegions[] = [];

    city: City;
    state: State;
    zipcode: PostalCode;

    partyRoleType!: PartyRoleTypes;

    constructor(
        private partiesService: PartiesService,
        private partyRolesService: PartyRolesService,
        private contactMechanismsService: ContactMechanismsService
    ) {
        this.city = new City();
        this.state = new State();
        this.zipcode = new PostalCode();
    }

    ngOnInit(): void {
        this.getPartyContactMechanisms();
        this.getContactMechanismTypes();
        this.getContactMechanismPurposeTypes();
        this.getPartyRoleType();
        this.getGeographicalRegion();
    }

    getPartyContactMechanisms() {
        this.partiesService.getPartyContactMechanisms(this.partyId).subscribe((res) => {
            this.partyContactMechanisms = res.partyContactMechanisms;

            this.removePartyContactMechanisms();
            this.buildPartyContactMechanisms();
        });
    }

    getContactMechanismTypes() {
        this.contactMechanismsService.indexContactMechanismTypes().subscribe((res: any) => {
            this.contactMechanismTypes = res.contactMechanismTypes;
        });
    }

    getGeographicalRegion() {
        this.contactMechanismsService.indexGeographicalRegions().subscribe((res: any) => {
            this.geographicalRegions = res.geographicalRegions;
        });
    }

    getPartyRoleType() {
        this.partyRolesService.indexPartyRoleTypesByCategory(this.type).subscribe((res) => {
            const type = this.type === 'People' ? 'Person' : this.type;

            this.partyRoleType = res.partyRoleTypes?.find((prt: PartyRoleTypes) => {
                return prt.TYPE === type;
            });

            this.buildPartyContactMechanisms();
        });
    }

    getContactMechanismPurposeTypes() {
        this.contactMechanismsService.indexContactMechanismPurposeTypes().subscribe((res: any) => {
            this.contactMechanismPurposeTypes = res.contactMechanismPurposeTypes;
        });
    }

    removePartyContactMechanisms() {
        if (this.partyContactMechanisms && this.partyContactMechanisms.length > 0) {
            this.removeContactPersonTypes.forEach((type) => {
                this.partyContactMechanisms = this.partyContactMechanisms.filter((pcm) => {
                    return pcm.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE !== type;
                });
            });
            this.removeAddressTypes.forEach((type) => {
                this.partyContactMechanisms = this.partyContactMechanisms.filter((pcm) => {
                    return pcm.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE !== type;
                });
            });
            this.removeEmailTypes.forEach((type) => {
                this.partyContactMechanisms = this.partyContactMechanisms.filter((pcm) => {
                    return pcm.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE !== type;
                });
            });
            this.removePhoneNumberTypes.forEach((type) => {
                this.partyContactMechanisms = this.partyContactMechanisms.filter((pcm) => {
                    return pcm.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE !== type;
                });
            });
        }
    }

    buildPartyContactMechanisms() {
        this.enabledTypes.forEach((enabledType) => {
            this.results[enabledType].enabled = true;
            this.results[enabledType].current = [];
            this.results[enabledType].past = [];
        });

        this.cleanDates();

        const now = new Date().getTime();

        this.partyContactMechanisms
            .sort((a, b) => {
                return (b.CREATED_DATE ? b.CREATED_DATE!.getTime() : now) - (a.CREATED_DATE ? a.CREATED_DATE!.getTime() : now);
            })
            .forEach((pcm) => {
                switch (pcm.CONTACT_MECHANISMS!.CONTACT_MECHANISM_TYPES!.TYPE) {
                    case 'Address':
                        if (!pcm.ID) {
                            this.results.postalAddresses.current.push(pcm);
                        } else if (
                            this.results!.postalAddresses!.current.find(
                                (cur) =>
                                    cur.ID &&
                                    cur.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE ===
                                        pcm.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE
                            )
                                ? false
                                : true
                        ) {
                            this.results.postalAddresses.current.push(pcm);
                        } else {
                            this.results.postalAddresses.past.push(pcm);
                        }
                        break;
                    case 'Phone':
                        if (!pcm.ID) {
                            this.results.phoneNumbers.current.push(pcm);
                        } else if (
                            this.results!.phoneNumbers!.current.find(
                                (cur) =>
                                    cur.ID &&
                                    cur.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE ===
                                        pcm.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE
                            )
                                ? false
                                : true
                        ) {
                            this.results.phoneNumbers.current.push(pcm);
                        } else {
                            this.results.phoneNumbers.past.push(pcm);
                        }
                        break;
                    case 'Email':
                        if (!pcm.ID) {
                            this.results.emails.current.push(pcm);
                        } else if (
                            this.results!.emails!.current.find(
                                (cur) =>
                                    cur.ID &&
                                    cur.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE ===
                                        pcm.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE
                            )
                                ? false
                                : true
                        ) {
                            this.results.emails.current.push(pcm);
                        } else {
                            this.results.emails.past.push(pcm);
                        }
                        break;
                    case 'Contact Person':
                        if (!pcm.ID) {
                            this.results.contactPersons.current.push(pcm);
                        } else if (
                            this.results!.contactPersons!.current.find(
                                (cur) =>
                                    cur.ID &&
                                    cur.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE ===
                                        pcm.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE
                            )
                                ? false
                                : true
                        ) {
                            this.results.contactPersons.current.push(pcm);
                        } else {
                            this.results.contactPersons.past.push(pcm);
                        }
                        break;
                }
            });
    }

    cleanDates() {
        this.partyContactMechanisms.forEach((pcm) => {
            pcm.CREATED_DATE = new CleanDatePipe().transform(pcm.CREATED_DATE!);
        });
    }

    // Edit functions
    insert(editing: keyof editPartyContactMechanismInterface) {
        this.results[editing].editing = false;
        this.isEditing = true;
        this.isEditingChange.emit(this.isEditing);

        switch (editing) {
            case 'postalAddresses':
                this.results[editing].edit = {
                    PARTY_ROLE_TYPES: this.partyRoleType,
                    PARTY_CONTACT_MECHANISM_PURPOSES: [{ CONTACT_MECHANISM_PURPOSE_TYPES: undefined }],
                    CONTACT_MECHANISMS: {
                        CONTACT_MECHANISM_TYPES: this.getContactMechanismType('Address'),
                        POSTAL_ADDRESSES: [
                            {
                                STREET_1: '',
                                STREET_2: '',
                                CITy: {
                                    STATE: {
                                        COUNTRy: {
                                            ID: 1
                                        }
                                    }
                                },
                                POSTAL_CODES: {}
                            }
                        ],
                        EMAILS: [],
                        TELEPHONE_NUMBERS: []
                    }
                };
                break;
            case 'phoneNumbers':
                this.results[editing].edit = {
                    PARTY_ROLE_TYPES: this.partyRoleType,
                    PARTY_CONTACT_MECHANISM_PURPOSES: [{ CONTACT_MECHANISM_PURPOSE_TYPES: undefined }],
                    CONTACT_MECHANISMS: {
                        CONTACT_MECHANISM_TYPES: this.getContactMechanismType('Phone'),
                        POSTAL_ADDRESSES: [{}],
                        EMAILS: [],
                        TELEPHONE_NUMBERS: [
                            {
                                PHONE_NUMBER: '',
                                EXT: ''
                            }
                        ]
                    }
                };
                break;
            case 'emails':
                this.results[editing].edit = {
                    PARTY_ROLE_TYPES: this.partyRoleType,
                    PARTY_CONTACT_MECHANISM_PURPOSES: [{ CONTACT_MECHANISM_PURPOSE_TYPES: undefined }],
                    CONTACT_MECHANISMS: {
                        CONTACT_MECHANISM_TYPES: this.getContactMechanismType('Email'),
                        POSTAL_ADDRESSES: [{}],
                        EMAILS: [
                            {
                                EMAIL_ADDRESS: ''
                            }
                        ],
                        TELEPHONE_NUMBERS: []
                    }
                };
                break;
            case 'contactPersons':
                this.results[editing].edit = {
                    PARTY_ROLE_TYPES: this.partyRoleType,
                    PARTY_CONTACT_MECHANISM_PURPOSES: [{ CONTACT_MECHANISM_PURPOSE_TYPES: this.getContactMechanismPurposeType('Administrator') }],
                    CONTACT_MECHANISMS: {
                        CONTACT_MECHANISM_TYPES: this.getContactMechanismType('Contact Person'),
                        POSTAL_ADDRESSES: [{}],
                        EMAILS: [],
                        TELEPHONE_NUMBERS: [],
                        CONTACT_PERSONS: [
                            {
                                FIRST_NAME: '',
                                LAST_NAME: ''
                            }
                        ]
                    }
                };
                break;
        }

        this.results[editing].inserting = true;
    }

    edit(editing: keyof editPartyContactMechanismInterface, edit?: PartyContactMechanisms) {
        this.results[editing].inserting = false;
        this.isEditing = true;
        this.isEditingChange.emit(this.isEditing);

        if (edit) {
            this.results[editing].edit = JSON.parse(JSON.stringify(edit));
            this.results[editing].target = edit;

            switch (editing) {
                case 'postalAddresses':
                    this.city = this.results[editing].edit.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!;
                    this.state = this.results[editing].edit.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!.STATE!;
                    this.zipcode = this.results[editing].edit.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].POSTAL_CODES!;
                    break;
                case 'phoneNumbers':
                    break;
                case 'emails':
                    break;
                case 'contactPersons':
                    break;
            }
        }
        console.warn(this.results[editing].edit);
        this.results[editing].editing = true;
    }

    getContactMechanismType(type: string): ContactMechanismTypes | undefined {
        let output: ContactMechanismTypes | undefined = new ContactMechanismTypes();
        output = this.contactMechanismTypes.find((contactMechanismType) => {
            return contactMechanismType.TYPE === type;
        });

        return output;
    }

    getContactMechanismPurposeType(type: string): any {
        let output: ContactMechanismPurposeTypes | undefined = new ContactMechanismPurposeTypes();
        output = this.contactMechanismPurposeTypes.find((contactMechanismPurposeType) => {
            return contactMechanismPurposeType.TYPE === type;
        });

        return output;
    }

    editDone(editing: keyof editPartyContactMechanismInterface) {
        this.buildPartyContactMechanisms();

        this.results[editing].inserting = false;
        this.results[editing].editing = false;
        this.results[editing].edit = {};
        this.results[editing].target = {};

        this.city = {};
        this.state = {};
        this.zipcode = {};

        let stillEditing = false;

        this.enabledTypes.forEach((enabledType) => {
            if (this.results[enabledType].inserting || this.results[enabledType].editing) {
                stillEditing = true;
            }
        });

        if (!stillEditing) {
            this.isEditing = false;
            this.isEditingChange.emit(this.isEditing);
        }

        this.emitChanges();
    }

    insertContactMechanism(editing: keyof editPartyContactMechanismInterface) {
        console.warn('Insert');
        console.warn(this.results[editing].edit);

        switch (editing) {
            case 'postalAddresses':
                this.results[editing].edit.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy = this.city;
                this.results[editing].edit.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!.STATE = this.state;
                this.results[editing].edit.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].POSTAL_CODES = this.zipcode;
                this.results[editing].edit.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].GEOGRAPHICAL_REGIONS = this.geographicalRegions[0];
                break;
            case 'phoneNumbers':
                break;
            case 'emails':
                break;
            case 'contactPersons':
                break;
        }

        //this.results[editing].current.push(JSON.parse(JSON.stringify(this.results[editing].edit)));
        this.partyContactMechanisms.push(JSON.parse(JSON.stringify(this.results[editing].edit)));

        console.warn(this.results[editing].current[this.results[editing].current.length - 1]);

        this.editDone(editing);
    }

    updateContactMechanism(editing: keyof editPartyContactMechanismInterface) {
        console.warn('Update');
        console.warn(this.results[editing].edit);

        switch (editing) {
            case 'postalAddresses':
                this.results[editing].edit.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy = this.city;
                this.results[editing].edit.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!.STATE = this.state;
                this.results[editing].edit.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].POSTAL_CODES = this.zipcode;
                break;
            case 'phoneNumbers':
                break;
            case 'emails':
                break;
            case 'contactPersons':
                break;
        }

        Object.assign(this.results[editing].target, JSON.parse(JSON.stringify(this.results[editing].edit)));

        this.editDone(editing);
    }

    deleteContactMechanism(editing: keyof editPartyContactMechanismInterface, deleted: PartyContactMechanisms, index: number) {
        console.warn('Delete');

        if (deleted.ID) {
            this.results[editing].delete.push(deleted);
        }

        this.partyContactMechanisms.splice(this.partyContactMechanisms.indexOf(deleted), 1);

        this.editDone(editing);
    }

    trackById(o1: any, o2: any) {
        if (!o1 || !o2) {
            return false;
        }

        return o1.ID === o2.ID;
    }

    // Sort functions
    sortContactMechanismPurposeTypes(property: keyof ContactMechanismPurposeTypes) {
        return this.contactMechanismPurposeTypes.sort((a, b) => (a[property]! > b[property]! ? 1 : a[property] === b[property] ? 0 : -1));
    }

    // Emitter functions
    emitChanges() {
        let output: { partyContactMechanisms: PartyContactMechanisms[]; deletePartyContactMechanisms: PartyContactMechanisms[] } = {
            partyContactMechanisms: [],
            deletePartyContactMechanisms: []
        };
        let keys: Array<keyof editPartyContactMechanismInterface> = <Array<keyof editPartyContactMechanismInterface>>Object.keys(this.results);

        keys.forEach((key) => {
            output.partyContactMechanisms = output.partyContactMechanisms.concat(this.results[key].current);
            output.deletePartyContactMechanisms = output.deletePartyContactMechanisms.concat(this.results[key].delete);
        });

        this.partyContactMechanismsChange.emit(output);
    }
}
